'use strict';

var classes = {"circle":"circle__8otSr","completed":"completed__1v-5a","in-progress":"in-progress__XnQBu","not-started":"not-started__rPPBU"};

module.exports = classes;
//# sourceMappingURL=circle-status.module.scss.js.map
